import gql from "graphql-tag"
import ORDER_FRAGMENT from "graphql/fragments/OrderFragment"

const UPDATE_ALL_ORDERS = gql`
  mutation UpdateAllOrders(
    $input: MutationUpdateOrdersContentFromOrderInput!
  ) {
    updateOrdersContentFromOrder(input: $input) {
      orders {
        ...OrderFragment
      }
    }
  }
  ${ORDER_FRAGMENT}
`

export default UPDATE_ALL_ORDERS
